import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {environment} from '../../environments/environment';

interface ConvertApiResponse {
  Files: { Url: string }[];
}

@Injectable({
  providedIn: 'root'
})
export class ConvertApiService {
  constructor(private http: HttpClient) {}


  convertExcelToPdf(blob: Blob): Observable<ConvertApiResponse> {
    const formData = new FormData();
  
    formData.append('File', blob, 'file.xlsx');
    formData.append('PageOrientation', 'landscape');
    formData.append('PageSize', 'tabloid');
    formData.append('StoreFile', 'True'); //returns URL. Otherwise returns filedata

    const url = 'https://v2.convertapi.com/convert/xlsx/to/pdf?Secret=' + environment.convertAPIKey; 
    return this.http.post<ConvertApiResponse>(url, formData);
  }
}
